import React from 'react'
import { AsLabel, CaptionMD, ParagraphSM } from '@/atoms/Text'
import { LandingReleaseCard } from '@/views/TicketsLandingView/LandingReleaseCard'
import { TicketsLandingRelease } from '@/views/TicketsLandingView/types'

export interface Props {
  heading: string
  subHeading: string
  releases: TicketsLandingRelease[]
}

export function ReleaseColumn({ heading, releases = [], subHeading }: Props) {
  return (
    <div className="relative max-w-[380px] py-6">
      <CaptionMD weight="bold" as={AsLabel} className="mb-3 !font-bold leading-8">
        {heading}
      </CaptionMD>
      <ParagraphSM className="pb-6 leading-7 text-gray-400">{subHeading}</ParagraphSM>
      {releases.map((release) => (
        <LandingReleaseCard release={release} key={release?.id} />
      ))}
      <div className="absolute left-6 top-0 h-full pb-32 pt-56 sm:pt-48">
        <div className="h-full border-r border-dashed border-r-core-gray-700" />
      </div>
    </div>
  )
}
